export const findPercent = (value: string, percent: number = 5) => {
  const numberValue = parseFloat(value);
  const percentValue = numberValue * (1 - percent / 100);
  return percentValue.toFixed(2).toString();
};
